import React, { useEffect, useState } from 'react';
import { Link, graphql, useStaticQuery } from 'gatsby';

import Logo from '../../assets/images/logo.png';
import Icon from '../Icon';

export default function Nav() {
  const [sidenav, setSidenav] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      document
        .querySelector('nav')
        .toggleAttribute('stuck', entry.isIntersecting);
    });

    observer.observe(document.querySelector('.nav-sticky-indicator'));

    return observer.disconnect;
  }, []);

  const data = useStaticQuery(graphql`
    query {
      nav: contentfulSiteWide(internalName: { eq: "Site Wide DO NOT DELETE" }) {
        id
        headerMenu {
          ... on ContentfulNavigationDropdown {
            id
            parentNavigationItem {
              name
              slug
            }
            pages {
              ... on ContentfulPages {
                name
                slug
              }
              ... on ContentfulStaticPage {
                name
                slug
              }
            }
            sys {
              contentType {
                sys {
                  id
                }
              }
            }
          }
          ... on ContentfulPages {
            name
            slug
            sys {
              contentType {
                sys {
                  id
                }
              }
            }
          }
          ... on ContentfulStaticPage {
            name
            slug
            sys {
              contentType {
                sys {
                  id
                }
              }
            }
          }
        }
        headerMenuTopRightButton {
          name
          slug
        }
      }
    }
  `);

  return (
    <>
      <nav className="nav">
        <div className="nav-wrapper">
          <div className="navLeft">
            <ul>
              <li>
                <Link to="/">
                  <img src={Logo} alt="CrossComm" className="logo" />
                </Link>
              </li>
              {data.nav.headerMenu.map((link) =>
                link.sys.contentType.sys.id === 'navigationDropdown' ? (
                  <li
                    key={link.parentNavigationItem.name}
                    className={link.parentNavigationItem.name.toLowerCase()}
                  >
                    <div className="dropdown">
                      <Link
                        to={`/${link.parentNavigationItem.slug}/`}
                        className="links dropbtn"
                        activeClassName="active"
                        partiallyActive
                      >
                        {link.parentNavigationItem.name}
                        <Icon
                          icon={['fas', 'caret-down']}
                          size="sm"
                          className="dropdown-icon"
                        />
                      </Link>
                      <div className="dropdown-content">
                        {link.pages.map((sublink) => (
                          <Link
                            key={sublink.name}
                            to={`/${link.parentNavigationItem.slug}/${sublink.slug}`}
                            className="links"
                            activeClassName="active"
                          >
                            {sublink.name}
                          </Link>
                        ))}
                      </div>
                    </div>
                  </li>
                ) : (
                  <li key={link.name} className={link.name.toLowerCase()}>
                    <Link
                      to={link.slug === 'home' ? '/' : `/${link.slug}/`}
                      className="links"
                      activeClassName="active"
                      partiallyActive={link.slug !== 'home'}
                    >
                      {link.name}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </div>
          <div className="navRight">
            <Link
              to={`/${data.nav.headerMenuTopRightButton.slug}/`}
              className="links"
              activeClassName="active"
              partiallyActive
            >
              {data.nav.headerMenuTopRightButton.name}
            </Link>
            {!sidenav ? (
              <button
                type="button"
                className="toggle"
                aria-label="Toggle navigation"
                onClick={() => setSidenav(!sidenav)}
              >
                <Icon icon="bars" size="sm" className="icon-color" />
              </button>
            ) : null}
          </div>
        </div>
        <div className={`sidenav ${!sidenav && 'sidenav-disable'}`}>
          <button
            type="button"
            className="toggle"
            aria-label="Toggle navigation"
            onClick={() => setSidenav(!sidenav)}
          >
            <Icon icon="times" size="sm" className="icon-color" />
          </button>
          <ul className={`side-links ${sidenav && 'side-links-animate'}`}>
            {data.nav.headerMenu.map((link) =>
              link.sys.contentType.sys.id === 'navigationDropdown' ? (
                <li key={link.parentNavigationItem.name}>
                  <div className="dropdown">
                    <Link
                      to={`/${link.parentNavigationItem.slug}/`}
                      activeClassName="active"
                      partiallyActive
                      onClick={() => setSidenav(!sidenav)}
                    >
                      {link.parentNavigationItem.name}
                      <Icon
                        icon={['fas', 'caret-down']}
                        size="sm"
                        className="dropdown-icon"
                      />
                    </Link>
                    <div className="dropdown-content">
                      {link.pages.map((sublink) => (
                        <Link
                          key={sublink.name}
                          to={`/${link.parentNavigationItem.slug}/${sublink.slug}`}
                          activeClassName="active"
                          onClick={() => setSidenav(!sidenav)}
                        >
                          {sublink.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                </li>
              ) : (
                <li key={link.name}>
                  <Link
                    to={link.slug === 'home' ? '/' : `/${link.slug}/`}
                    activeClassName="active"
                    partiallyActive={link.slug !== 'home'}
                    onClick={() => setSidenav(!sidenav)}
                  >
                    {link.name}
                  </Link>
                </li>
              )
            )}
            <li className="side-button">
              <Link
                to={`/${data.nav.headerMenuTopRightButton.slug}/`}
                activeClassName="active"
                partiallyActive
                onClick={() => setSidenav(!sidenav)}
              >
                {data.nav.headerMenuTopRightButton.name}
              </Link>
            </li>
          </ul>
        </div>
      </nav>
      <div className="nav-sticky-indicator" />
    </>
  );
}
